import * as React from 'react';
import './AppPartner.css';

export default function AppPartner() {
    return (
        <div className="app-partner">
            <h1>Getting Started with the API</h1>
            <div className="info-section" id="install-app">
                <h3>Installing an App</h3>
                <ol>
                    <li>
                        Create a test user account by clicking on the test user signup URL in the app created
                        email. Make sure to validate the account by clicking the link in the email you receive after account creation.
                        <p><strong>Note:</strong> Test accounts are valid for 180 days.</p>
                    </li>
                    <li>
                        While logged into your test user account, click the private app url provided in the app created email to access your app.
                    </li>
                    <li>
                        After navigating to the private app url, click on the install icon and then accept and install.
                    </li>
                </ol>
                <div className="centered"><img src="https://cdn.skubana.com/email/oauthapi-step1-4.png" alt=""/>
                </div>
                <p>Once the permissions are approved, the authorization code will be generated by Skubana and a
                    request will be made to the "post approval redirect URL" you specified during app creation with
                    the 'code' and 'cid' parameters appended to
                    the URL. (If you did not specify a "post approval redirect URL," this will be a link to the app
                    store with the 'code' and 'cid' parameters still present.) This exact same URL will later be
                    used to generate the access token as seen in the
                    "Generate Access Token" section below.</p>
                <p><strong>Note:</strong> We have provided the post approval redirect URL in the app created email.</p>
                <div className="centered"><img src="https://cdn.skubana.com/email/oauthapi-step1-5.png" alt=""/>
                </div>
                <p>Once the authorization code is received, follow the steps below to generate an access token.</p>
                <p><strong>Note:</strong> This authorization code can be consumed only once. If an error occurs
                    while generating the access token you will need to generate a new authorization code. To do so,
                    simply uninstall the app from the Skubana App Store and reinstall it; a new code will be
                    generated.</p>
            </div>
            <hr/>
            <div className="info-section" id="generate-access-token">
                <h3>Generating an Access Token</h3>
                <p>To generate an access token, the app must send a <strong>POST</strong> request to Skubana with 2
                    parameters, the <strong>authorization code</strong> and the <strong>app access key</strong>.</p>
                <p><strong>Authorization code:</strong> This is the code acquired by following the app install
                    process detailed above.</p>
                <p><strong>App access key:</strong> This is a Base64 encoding of your appKey and appSecret (provided
                    in the app created email).</p>
                <div className="code-snippet-container indented">
                    <div className="code-snippet">
                        <p>Javascript example:</p>
                        <code>window.btoa("YOUR_APP_KEY:YOUR_APP_SECRET");</code>
                    </div>
                    <div className="code-snippet">
                        <p>Java example:</p>
                        <code>java.util.Base64.getEncoder().encodeToString(new String(YOUR_APP_KEY + ":" +
                            YOUR_APP_SECRET).getBytes());</code>
                    </div>
                </div>
                <p>Now that you have generated your access key, follow these steps to request your access token.</p>
                <ol>
                    <li>
                        Create the URL for your request.
                        <ol>
                            <li>
                                <p>
                                    URL Format:
                                </p>
                                <p className="indented">https://(<b>app</b>|<b>demo</b>).skubana.com/oauth/token?grant_type=authorization_code&code=&lt;<b>code</b>&gt;&redirect_uri=&lt;<b>redirectUri</b>&gt;?cid=&lt;<b>cid</b>&gt;</p>
                            </li>
                            <li>
                                <p>
                                    Example URL (for production environment, use demo.skubana.com for demo):
                                </p>
                                <p className="indented">https://<b>app</b>.skubana.com/oauth/token?grant_type=authorization_code&code=<b>AjSxNb</b>&redirect_uri=<b>https://app.skubana.com/appstore</b>?cid=<b>Z12tcGFueUlkMTIzGHV1</b></p>
                            </li>
                        </ol>
                    </li>
                    <li>
                        <p>Make a POST request to the URL you have created with the following header:</p>
                    </li>
                </ol>
                <p className="indented">Headers: Authorization: Basic YOUR_APP_ACCESS_KEY</p>
                <p><strong>Once Skubana receives the generate access token POST request, it will return the
                    following JSON in the response:</strong></p>
                <p>
                    <code>{'{"access_token":"<your access token>","token_type":"bearer","scope":"<the user-approved permissions>"}'}</code>
                </p>
                <div><strong>Note:</strong> Your access token should be securely stored and only used for API requests. Skubana will never ask you for your access token.</div>
            </div>
            <hr/>
            <div className="info-section" id="make-api-call">
                <h3>Making an API Call</h3>
                <p>The base url should https://api.demo.skubana.com or https://api.skubana.com depending on your environment.</p>
                <p>When making calls, you just need an Authorization header that includes your access token.</p>
                <p className="indented">Headers: Authorization: Bearer YOUR_ACCESS_TOKEN</p>
                <div className="centered">
                    <div className="button">
                        <a href="/spec/">Click here for the Full API Reference</a>
                    </div>
                </div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/pages/AppPartner/AppPartner.tsx